import { render, staticRenderFns } from "./outward.vue?vue&type=template&id=42401672&scoped=true&"
import script from "./outward.vue?vue&type=script&lang=js&"
export * from "./outward.vue?vue&type=script&lang=js&"
import style0 from "./outward.vue?vue&type=style&index=0&id=42401672&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42401672",
  null
  
)

export default component.exports